'use client';

import type { MouseEvent, ReactNode } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

type MarketingNavLinkProps = {
  href: string;
  className?: string;
  children: ReactNode;
  onClick?: () => void;
};

export function scrollToMarketingSection(sectionId: string, behavior: ScrollBehavior = 'smooth') {
  const element = document.getElementById(sectionId);
  if (!element) return false;
  element.scrollIntoView({ behavior, block: 'start' });
  return true;
}

export function MarketingNavLink({ href, className, children, onClick }: MarketingNavLinkProps) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    onClick?.();

    const hashIndex = href.indexOf('#');
    if (hashIndex === -1) return;

    const path = href.slice(0, hashIndex) || '/';
    const sectionId = href.slice(hashIndex + 1);
    if (!sectionId) return;

    event.preventDefault();

    if (pathname === path) {
      scrollToMarketingSection(sectionId);
      window.history.replaceState(null, '', `${path}#${sectionId}`);
      return;
    }

    navigate({ pathname: path, hash: `#${sectionId}` });
  };

  return (
    <Link to={href} onClick={handleClick} className={className}>
      {children}
    </Link>
  );
}
